import { render, staticRenderFns } from "./residentialQuarters.vue?vue&type=template&id=57187b20&scoped=true&"
import script from "./residentialQuarters.vue?vue&type=script&lang=js&"
export * from "./residentialQuarters.vue?vue&type=script&lang=js&"
import style0 from "./residentialQuarters.vue?vue&type=style&index=0&id=57187b20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57187b20",
  null
  
)

export default component.exports